const { createAction } = require('../helpers')
const {
  GET_PLAN_LIST,
  GET_PLAN_LIST_SUCCESS,
  GET_PLAN_LIST_ERROR,
  GET_PLAN_LIST_RESET,

  GET_PLAN,
  GET_PLAN_SUCCESS,
  GET_PLAN_ERROR,
  GET_PLAN_RESET,

  CREATE_PLAN,
  CREATE_PLAN_SUCCESS,
  CREATE_PLAN_ERROR,
  CREATE_PLAN_RESET,

  UPDATE_PLAN,
  UPDATE_PLAN_SUCCESS,
  UPDATE_PLAN_ERROR,
  UPDATE_PLAN_RESET,

  DELETE_PLAN,
  DELETE_PLAN_SUCCESS,
  DELETE_PLAN_ERROR,
  DELETE_PLAN_RESET,

  GET_PLAN_FOR_PRICE,
  GET_PLAN_FOR_PRICE_SUCCESS,
  GET_PLAN_FOR_PRICE_ERROR,
  GET_PLAN_FOR_PRICE_RESET,
} = require('./constants')

// eslint-disable-next-line max-len
const getPlanList = ({ skip, take, search }) => createAction(GET_PLAN_LIST, { skip, take, search })
const getPlanListSuccess = data => createAction(GET_PLAN_LIST_SUCCESS, { data })
const getPlanListError = error => createAction(GET_PLAN_LIST_ERROR, { error })
const getPlanListReset = () => createAction(GET_PLAN_LIST_RESET)

const getPlan = id => createAction(GET_PLAN, { id })
const getPlanSuccess = data => createAction(GET_PLAN_SUCCESS, { data })
const getPlanError = error => createAction(GET_PLAN_ERROR, { error })
const getPlanReset = () => createAction(GET_PLAN_RESET)

const createPlan = planData => createAction(CREATE_PLAN, { planData })
const createPlanSuccess = data => createAction(CREATE_PLAN_SUCCESS, { data })
const createPlanError = error => createAction(CREATE_PLAN_ERROR, { error })
const createPlanReset = () => createAction(CREATE_PLAN_RESET)

const updatePlan = ({ id, planData }) => createAction(UPDATE_PLAN, { id, planData })
const updatePlanSuccess = data => createAction(UPDATE_PLAN_SUCCESS, { data })
const updatePlanError = error => createAction(UPDATE_PLAN_ERROR, { error })
const updatePlanReset = () => createAction(UPDATE_PLAN_RESET)

const deletePlan = ({ id }) => createAction(DELETE_PLAN, { id })
const deletePlanSuccess = data => createAction(DELETE_PLAN_SUCCESS, { data })
const deletePlanError = error => createAction(DELETE_PLAN_ERROR, { error })
const deletePlanReset = () => createAction(DELETE_PLAN_RESET)

const getPlanForPrice = id => createAction(GET_PLAN_FOR_PRICE, { id })
const getPlanForPriceSuccess = data => createAction(GET_PLAN_FOR_PRICE_SUCCESS, { data })
const getPlanForPriceError = error => createAction(GET_PLAN_FOR_PRICE_ERROR, { error })
const getPlanForPriceReset = () => createAction(GET_PLAN_FOR_PRICE_RESET)

module.exports = {
  getPlanList,
  getPlanListSuccess,
  getPlanListError,
  getPlanListReset,
  getPlan,
  getPlanSuccess,
  getPlanError,
  getPlanReset,
  createPlan,
  createPlanSuccess,
  createPlanError,
  createPlanReset,
  updatePlan,
  updatePlanSuccess,
  updatePlanError,
  updatePlanReset,
  deletePlan,
  deletePlanSuccess,
  deletePlanError,
  deletePlanReset,
  getPlanForPrice,
  getPlanForPriceSuccess,
  getPlanForPriceError,
  getPlanForPriceReset,
}
